export const getProjectStatusColor = (statusId: number) => {
  switch (statusId) {
    //vob
    case 1:
      return "#E8F7FF";
    //planning
    case 2:
      return "#D0EEFF";
    //installation
    case 3:
      return "#B1E3FF";
    //abnahme
    case 4:
      return "#8EC7E7";
    //qc
    case 5:
      return "#BBB8F3";
    //post installation
    case 6:
      return "#FCD3AC";
    //done
    case 7:
      return "#A1E3CB";
    //canceled
    case 8:
      return "#F4B6B2";
    default:
      return "#E3E1EA";
  }
};

export const getPhaseStatusColor = (statusId: number) => {
  switch (statusId) {
    //open
    case 1:
      return "#E8F7FF";
    //scheduled
    case 2:
      return "#D0EEFF";
    //installation
    case 3:
      return "#B1E3FF";
    //abnahme
    case 4:
      return "#8EC7E7";
    //qc
    case 5:
      return "#BBB8F3";
    //completed
    case 6:
      return "#A1E3CB";
    //failed
    case 7:
      return "#F4B6B2";
    //pending-qc pending-abnahme
    case 8:
    case 9:
      return "#FCD3AC";
    default:
      return "#E3E1EA";
  }
};

export const getPhaseStatusBorder = (statusId: number) => {
  switch (statusId) {
    //open
    case 1:
      return "#51687A";
    //scheduled
    case 2:
      return "#51687A";
    //installation
    case 3:
      return "#51687A";
    //abnahme
    case 4:
      return "#51687A";
    //qc
    case 5:
      return "#51687A";
    //completed
    case 6:
      return "#51687A";
    //failed
    case 7:
      return "#A6544F";
    //pending-qc pending-abnahme
    case 8:
    case 9:
      return "#A6544F";
    default:
      return "#51687A";
  }
};
export const getTerminStatusColor = (statusId: number) => {
  switch (statusId) {
    //open
    case 1:
      return "#E8F7FF";
    //proposed
    case 2:
      return "#D0EEFF";
    //confirmed
    case 3:
      return "#B1E3FF";
    //in_progress
    case 4:
      return "#8EC7E7";
    //completed
    case 5:
      return "#A1E3CB";
    //failed
    case 6:
      return "#F4B6B2";
    default:
      return "#BAEDBD";
  }
};

export const getTerminStatusBorder = (statusId: number) => {
  switch (statusId) {
    //open
    case 1:
      return "#51687A";
    //proposed
    case 2:
      return "#51687A";
    //confirmed
    case 3:
      return "#51687A";
    //in_progress
    case 4:
      return "#51687A";
    //completed
    case 5:
      return "#51687A";
    //failed
    case 6:
      return "#A6544F";
    default:
      return "#BAEDBD";
  }
};

// export const formatStatusName = (status: string) => {
//   return status
//     ? status.charAt(0).toUpperCase() + status.slice(1).replace(/[_-]/g, " ")
//     : "";
// };

// export const getDownloadStatusColor = (status: string) => {
//   switch (status) {
//     case "in-progress":
//       return "#A8C5DA";
//     case "ready-to-download":
//       return "#B1E3FF";
//     default:
//       return "#E5ECF6";
//   }
// };

// export const getDownloadStatusName = (status: string) => {
//   switch (status) {
//     case "in-progress":
//       return "In Progress";
//     case "ready-to-download":
//       return "Ready to Download";
//     case "downloaded":
//       return "Downloaded";
//     default:
//       return status;
//   }
// };
